import React from 'react';
import { DatePickerCustom } from '../../../../../../../components/DatePickerCustom';
import { Form } from 'antd';
import { fieldNames } from '../../../common/config';
import { compareToStartDate } from '../../../common/lib/fieldValidators';

const planEndDateFieldName = fieldNames.planEndDate;
const FormItem = Form.Item;

const PlanEndDateField = ({ form }) => {
  return (
    <FormItem
      label="Дата завершения (план)"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(planEndDateFieldName, {
        rules: [
          {
            type: 'object',
            required: true,
            message: 'Укажите дату',
          },
          { validator: compareToStartDate(form) },
        ],
      })(
        <DatePickerCustom
          size="large"
          style={{ width: '100%' }}
          placeholder="DD.MM.YYYY HH:mm"
          format="DD.MM.YYYY HH:mm"
          showTime={{ format: 'HH:mm', minuteStep: 10 }}
        />
      )}
    </FormItem>
  );
};

export default PlanEndDateField;
